<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="120px" v-loading="loading">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="outboundNumber" label="出库单号">
              {{ formData.outboundNumber || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="deliveryDate" label="发货日期">
              {{ formData.ctime || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="specName" label="品种规格">
              {{ formData.specName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="quantity" label="数量">
              {{ formData.quantity || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="productionDate" label="生产日期">
              {{ formData.productionDate || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="shelfLife" label="保质期">
              {{ formData.shelfLife || '--' }}
            </el-form-item>
          </el-col>
          <!-- 罐号放在保质期下面 -->
          <el-col :span="12">
            <el-form-item prop="tankNumber" label="罐号">
              {{ formData.tankNumber || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleNumber" label="车船号">
              {{ formData.vehicleNumber || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverName" label="司机姓名">
              {{ formData.driverName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverMobile" label="司机号码">
              {{ formData.driverMobile || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="contactName" label="客户联系人">
              {{ formData.contactName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="userName" label="客户">
              {{ formData.userName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="customerAddress" label="客户地址">
              {{ formData.customerAddress || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="customerMobile" label="客户号码">
              {{ formData.customerMobile || '--' }}
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 新增附件 -->
        <el-row>
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <media-upload readonly v-model="formData.fileList"></media-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">返回</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'ShipRecordDetail',
  data () {
    return {
      formData: {
        outboundNumber: '',
        deliveryDate: '',
        specName: '',
        quantity: '',
        productionDate: '',
        shelfLife: '',
        tankNumber: '',
        vehicleNumber: '',
        driverName: '',
        driverMobile: '',
        customerName: '',
        userName: '',
        customerAddress: '',
        customerMobile: '',
        fileList: []
      },
      loading: false
    }
  },
  created () {
    if (this.outboundId) {
      this.loadData()
    }
  },
  computed: {
    outboundId () {
      return this.$route.query.outboundId
    }
  },
  methods: {
    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.shipRecord.selectYxOutboundOrderByOutboundId, {
          params: { outboundId: this.outboundId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {
  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
  .el-upload-list {
    max-width: 100% !important;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
